import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuthStore from '@/store/authStore';
import Logo from '@/components/ui/Logo';
import Input from '@/components/ui/Input';
import Button from '@/components/ui/Button';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import styles from '../Login/Login.module.css';

export default function Register() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const register = useAuthStore((s) => s.register);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim() || !email.trim() || password.length < 6) {
      setError(t('auth.fillAll'));
      return;
    }
    setLoading(true);
    try {
      // O web é a área do personal/admin; aluno se cadastra pelo app.
      const user = await register({ name: name.trim(), email: email.trim(), password, role: 'trainer' });
      navigate(user.role === 'admin' ? '/admin' : '/trainer');
    } catch (err) {
      setError(err.message || t('auth.invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.lang}>
        <LanguageSwitcher />
      </div>
      <form className={styles.card} onSubmit={handleSubmit}>
        <Logo size={40} />
        <p className={styles.tagline}>{t('auth.registerSubtitle')}</p>

        <Input id="name" label={t('auth.name')} value={name} onChange={(e) => setName(e.target.value)} placeholder="Seu nome" required />
        <Input
          id="email"
          type="email"
          label={t('auth.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@email.com"
          required
        />
        <Input
          id="password"
          type="password"
          label={t('auth.password')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />

        {error && <div className={styles.error}>{error}</div>}

        <Button type="submit" fullWidth loading={loading}>
          {t('auth.createAccount')}
        </Button>

        <p className={styles.footer}>
          {t('auth.haveAccount')}{' '}
          <button type="button" className={styles.link} onClick={() => navigate('/login')}>
            {t('auth.signIn')}
          </button>
        </p>
        <p className={styles.footer}>{t('auth.studentUseApp')}</p>
      </form>
    </div>
  );
}
